import Vue from 'vue'
import Router from 'vue-router'
import Book from '../views/Book.vue'
import Errorpage from '../views/Error.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/404',
      name: 'error',
      component: Errorpage
    },
    {
      path: '/:bookIndex?',
      name: 'books',
      component: Book
    },
    {
      path: '/extra/:bookIndex/:extraChapter?/:extraItem?',
      name: 'books_extra_external',
      component: Book,
      meta: {
        extra: true
      }
    },
    {
      path: '/:bookId/:stub/:extraBook?/:extraChapter?/:extraItem?',
      name: 'book',
      component: Book,
      meta: {
        extra: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js